module.exports = __webpack_public_path__ + "img/video-icon.ae6db89c.png";